import FJViewConstant from "../../constant/FJViewConstant";
import FJActionConstant from "../../constant/FJActionConstant";
import FJUtil from "../../util/FJUtil";

const initState = {
	activeOption: FJViewConstant.STOCK_VIDEO_VIDEO,

	audioCategories: [
		{
			"key": "mood",
			"subcategories": ["angry", "dark", "epic", "happy", "inspiring", "love", "playful", "relaxing", "sad", "serious"]
		}, {
			"key": "genre",
			"subcategories": ["ambient", "blues", "bumpers-and-stingers", "chill-out", "cinematic", "classical", "corporate", "country", "electronic", "folk", "hip-hop", "holidays-and-special-events", "horror", "jazz", "kids-and-family", "pop", "religious", "rhythm-and-blues", "rock", "world"]
		}, {
			"key": "instrument",
			"subcategories": ["brass", "guitar-instrument", "orchestra", "percussion-instrument", "piano", "synth", "vocals", "woodwind"]
		}, {"key": "sound-effects", "subcategories": []}],
  searchAudios: [],
  searchAudioKeyword: '',
  searchAudioHistory: FJUtil.getSearchHistory(FJViewConstant.SEARCH_STOCK_MUSIC),
  searchAudioMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
  audioCollectionMode: FJViewConstant.STOCK_SEARCH_LOADING,
	searchAudioSortType: FJViewConstant.SORT_TYPE_RELEVANT,
	searchAudioFilter: {mood: '', genre: '', instrument: '', duration: [0, 240]},
  searchAudioPage: 0,
  searchAudioTotal: 0,
  audioPanelType: 1,

  searchVideoKeyword: '',
  searchVideos: [],
  searchVideoHistory: FJUtil.getSearchHistory(FJViewConstant.SEARCH_STOCK_VIDEO),
  searchVideoMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
  searchVideoSortType: FJViewConstant.SORT_TYPE_RELEVANT,
  searchVideoPage: 0,
  searchVideoTotal: 0,
  videoPanelType: 1,

  searchImageKeyword: '',
  searchImages: [],
  searchImageHistory: FJUtil.getSearchHistory(FJViewConstant.SEARCH_STOCK_IMAGE),
  searchImageMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
  searchImagePage: 0,
  searchImageTotal: 0,
  imagePanelType: 1,
};


export default function (state = initState, action) {
	switch (action.type) {
		case FJActionConstant.CUT_STOCK_VIDEO_OPTION:
			return {
				...state,
				activeOption: action.activeOption
			}

    case FJActionConstant.SET_STOCK_VIDEO_STATUS:
	    console.log(action.data.searchAudios);
      return {
        ...state,
        ...action.data,
      }
    case FJActionConstant.SET_STOCK_IMAGE_STATUS:
      return {
        ...state,
        ...action.data,
      }
    case FJActionConstant.SET_STOCK_AUDIO_STATUS:
	    return {
        ...state,
        ...action.data,
      }
    case FJActionConstant.SET_SEARCH_AUDIOS:
      return {
        ...state,
        searchAudios: action.searchAudios,
      }
    case FJActionConstant.SET_SEARCH_IMAGES:
      return {
        ...state,
        searchImage: action.searchImage,
      }
		default:
			return state;
	}
}